import React from 'react';
import {Button, ButtonGroup, Col, Dropdown, DropdownButton, Row} from "react-bootstrap";

const CheckboxShiftBalance = ({balance, onRefreshBalance, onServiceOutgoing, onCloseShift}) => {

  const formatBalance = () => {
    const serviceIn = parseInt(balance.service_in / 100);
    const cashSales = balance.cash_sales ? parseInt(balance.cash_sales / 100) : 0;
    const cardSales = balance.card_sales ? parseInt(balance.card_sales / 100) : 0;

    let formatted = `Служб. внесення: ${serviceIn} грн; Готівка: ${cashSales} грн; Безготівка: ${cardSales} грн;`;
    if (balance.service_out) {
      formatted += ` Служб. видача: ${parseInt(balance.service_out / 100)} грн;`;
    }
    return formatted;
  };

  return (
    <Row className='pb-2'>
      <Col xs={10}>
        <div>
          Готівка в касі: <b>{parseInt(balance.balance / 100)} грн.</b>
        </div>
        {formatBalance()}
      </Col>
      <Col className='text-right'>
        <ButtonGroup style={{marginTop: '4px', width: '100%'}}>
          <Button
            variant="outline-secondary"
            onClick={onRefreshBalance}
          >Оновити баланс</Button>
          <DropdownButton
            id='dropdown'
            as={ButtonGroup}
            title=''
            variant="outline-secondary"
          >
            <Dropdown.Item onClick={onServiceOutgoing}>Службова видача</Dropdown.Item>
            <Dropdown.Item onClick={onCloseShift}>Закрити зміну</Dropdown.Item>
          </DropdownButton>
        </ButtonGroup>
      </Col>
    </Row>
  );
}

export default CheckboxShiftBalance;
